"use strict";
var ACC;
ACC.accordion = {
	/* Requires jQuery
	 * Creates an Accordian effect for passed container (jQuery object) and identified child activators. 
	
	You can either trigger these automatically by appropriate HTML.
	Here, the important bits are the class "accordion", and the aria-controls attribute.
	See the ACC.accordion._constants for other attribute values in play.
	
	The HTML used (e.g. <ul> or <div> and, <a> or <button>) doesn't matter.
	
	<div class="accordion">
		<a href="javascript:void(0);" class="arrow-icon" aria-controls="somelinks" aria-expanded="false">
			<span class="txt">ABC...</span>
			<span class="icon icon-down-open-mini" aria-hidden="true"></span>
		</a>
		<ul id="somelinks">
			<li>...</li>
		</ul>
	
		<a href="javascript:void(0);" class="arrow-icon" aria-controls="somecontent" aria-expanded="false">
			<span class="txt">DEF...</span>
			<span class="icon icon-down-open-mini" aria-hidden="true"></span>
		</a>
		<div id="somecontent">
			<p>...</p>
		</div>
	</div>
	
	...or you call them explicitly, like this:
	ACC.accordion.bindAccordionEvent($(".some-element"), ".different-activator-element");
	
	You should ensure the initial visual state of toggled elements reflects the initial aria-expanded value.
	e.g. On page load... 
		if you set the activator as aria-expanded="false", 
		then you should set the controlled element as display:none. 
	 */
	
	_autoload: [
		"init" 
	],
	
	// Add your constants here.
	_constants: {
		ARIA_EXPANDED: "aria-expanded",
		CLASS_COMPONENT: "accordion",
		CSS_CLOSE_CLASS: "icon-down-open-mini",
		CSS_ICON_CLASS: "icon",
		CSS_OPEN_CLASS: "icon-up-open-mini",
		CONTROL_ATTRIBUTE: "aria-controls", // Attribute on activator that contains ID for area to open/close.
		SELECTOR_DEFAULT_ACTIVATOR: ".arrow-icon", // Default selector for child elements that control (open/close)
		SELECTOR_ICON: ".icon"
	},
	
	// Look for anything declared to be an accordion (ie. requires functionality)
	init: function() {
		var AC = ACC.accordion;
		var c = AC._constants;
		$("." + c.CLASS_COMPONENT).each(function() {
			AC.bindAccordionEvent($(this), c.SELECTOR_DEFAULT_ACTIVATOR);
		});
	},
	
	// Closes an open target element.
	// @$node (jQuery object) which activator was clicked. 
	closeAction: function($node) {
		var c = ACC.accordion._constants;
		var $icon = $node.find(c.SELECTOR_ICON);
		$("#" + $node.attr(c.CONTROL_ATTRIBUTE)).slideUp();
		$node.attr(c.ARIA_EXPANDED, false);
		$icon.removeClass(c.CSS_OPEN_CLASS);
		$icon.addClass(c.CSS_CLOSE_CLASS);
	},
	
	// Open a closed target element.
	// @$node (jQuery object) which activator was clicked. 
	openAction: function($node) {
		var c = ACC.accordion._constants;
		var $icon = $node.find(c.SELECTOR_ICON);
		$("#" + $node.attr(c.CONTROL_ATTRIBUTE)).slideDown();
		$node.attr(c.ARIA_EXPANDED, true);
		$icon.removeClass(c.CSS_CLOSE_CLASS);
		$icon.addClass(c.CSS_OPEN_CLASS);
	},
	
	// If the ARIA_EXPANDED state is false, we should set initial view state
	// of the controlled elements to closed.
	// @container (jQuery object) Element you have turned into an Accordion
	setInitialViewState: function($container) {
		var AC = ACC.accordion;
		var c = AC._constants;
		$container.find("[" + c.ARIA_EXPANDED + "=false]").each(function() {
			var $this = $(this);
			if($this.attr(c.ARIA_EXPANDED) != "true") {
				$container.find("#" + $this.attr(c.CONTROL_ATTRIBUTE)).hide();
			}
		});
	},
	
	// Adds accordion functionality to passed container.
	// @$container (jQuery object) Element you want to enhance with functionality.
	// @activators (String) jQuery selector for finding activators.
	bindAccordionEvent: function ($container, activators) {
		var AC = ACC.accordion;
		AC.setInitialViewState($container);
		$container.on("click", activators, function() {
			var $this = $(this);
			if($this.attr(ACC.accordion._constants.ARIA_EXPANDED) === "true") {
				// The one clicked was open so just close it.
			 	AC.closeAction($this);
			}
			else {
				// Close any already open.
				$container.find(activators).each(function() {
					AC.closeAction($(this));
				});
			
				// The one clicked was closed so open it.
				AC.openAction($this);
			}
		});
	}
};